import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { Toaster } from "./components/ui/sonner";
import SEOHead, { HelmetProvider } from "./components/SEOHead";
import CookieConsent from "./components/CookieConsent";

// Layout
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";

// Sections
import HeroSection from "./components/sections/HeroSection";
import WhatWeDoSection from "./components/sections/WhatWeDoSection";
import ExperiencesSection from "./components/sections/ExperiencesSection";
import ServicesSection from "./components/sections/ServicesSection";
import HowItWorksSection from "./components/sections/HowItWorksSection";
import SpecializationSection from "./components/sections/SpecializationSection";
import WhyUsSection from "./components/sections/WhyUsSection";
import CTASection from "./components/sections/CTASection";
import ContactSection from "./components/sections/ContactSection";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-black" data-testid="home-page">
      <SEOHead />
      <Header />
      <main>
        <HeroSection />
        <WhatWeDoSection />
        <ExperiencesSection />
        <ServicesSection />
        <HowItWorksSection />
        <SpecializationSection />
        <WhyUsSection />
        <CTASection />
        <ContactSection />
      </main>
      <Footer />
      <CookieConsent />
    </div>
  );
};

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="*" element={<HomePage />} />
            </Routes>
          </BrowserRouter>
          <Toaster />
        </div>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
